// Custom Slider Class để thay thế Swiper cho mobile
class CustomSlider {
    constructor(container, options = {}) {
        this.container = container;
        this.wrapper = container.querySelector('.swiper-wrapper');
        this.slides = Array.from(this.wrapper.children);
        this.currentIndex = 0;
        this.isTransitioning = false;
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.autoplayInterval = null;
        
        this.options = {
            autoplay: options.autoplay || false,
            autoplayDelay: options.autoplayDelay || 4000,
            pagination: options.pagination || null,
            ...options
        };
        
        this.init();
    }
    
    init() {
        if (this.slides.length === 0) return;
        
        // Setup styles cho wrapper và slides
        this.wrapper.style.cssText = `
            display: flex;
            transition: transform 0.3s ease;
            width: ${this.slides.length * 100}%;
        `;
        
        this.slides.forEach(slide => {
            slide.style.width = `${100 / this.slides.length}%`;
            slide.style.flexShrink = 0;
        });
        
        this.setupPagination();
        this.setupTouchEvents();
        this.setupAutoplay();
        this.goToSlide(0);
    }
    
    setupPagination() {
        if (!this.options.pagination) return;
        
        const paginationEl = document.querySelector(this.options.pagination);
        if (!paginationEl) return;
        
        // Xóa pagination cũ nếu có
        paginationEl.innerHTML = '';
        
        // Tạo pagination bullets tương ứng với số slide
        for (let i = 0; i < this.slides.length; i++) {
            const bullet = document.createElement('span');
            bullet.className = 'swiper-pagination-bullet';
            bullet.setAttribute('aria-label', `Go to slide ${i + 1}`);
            
            // Thêm event listener
            bullet.addEventListener('click', () => {
                this.goToSlide(i);
            });
            
            paginationEl.appendChild(bullet);
        }
        
        this.updatePagination();
    }
    
    updatePagination() {
        if (!this.options.pagination) return;
        
        const paginationEl = document.querySelector(this.options.pagination);
        if (!paginationEl) return;
        
        const bullets = paginationEl.querySelectorAll('.swiper-pagination-bullet');
        bullets.forEach((bullet, index) => {
            if (index === this.currentIndex) {
                bullet.classList.add('swiper-pagination-bullet-active');
            } else {
                bullet.classList.remove('swiper-pagination-bullet-active');
            }
        });
    }
    
    setupTouchEvents() {
        this.container.addEventListener('touchstart', (e) => {
            this.touchStartX = e.touches[0].clientX;
            this.stopAutoplay();
        }, { passive: true });
        
        this.container.addEventListener('touchend', (e) => {
            this.touchEndX = e.changedTouches[0].clientX;
            this.handleSwipe();
            this.startAutoplay();
        }, { passive: true });
        
        // Mouse events for desktop testing
        this.container.addEventListener('mousedown', (e) => {
            this.touchStartX = e.clientX;
            this.stopAutoplay();
        });
        
        this.container.addEventListener('mouseup', (e) => {
            this.touchEndX = e.clientX;
            this.handleSwipe();
            this.startAutoplay();
        });
    }
    
    handleSwipe() {
        const diff = this.touchStartX - this.touchEndX;
        const threshold = 50;
        
        if (Math.abs(diff) > threshold) {
            if (diff > 0) {
                // Swipe left - next slide
                this.next();
            } else {
                // Swipe right - previous slide
                this.prev();
            }
        }
    }
    
    setupAutoplay() {
        if (this.options.autoplay) {
            this.startAutoplay();
        }
    }
    
    startAutoplay() {
        if (!this.options.autoplay) return;
        
        this.stopAutoplay();
        this.autoplayInterval = setInterval(() => {
            this.next();
        }, this.options.autoplayDelay);
    }
    
    stopAutoplay() {
        if (this.autoplayInterval) {
            clearInterval(this.autoplayInterval);
            this.autoplayInterval = null;
        }
    }
    
    goToSlide(index) {
        if (this.isTransitioning || index < 0 || index >= this.slides.length) return;
        
        this.isTransitioning = true;
        this.currentIndex = index;
        
        const translateX = -(index * (100 / this.slides.length));
        this.wrapper.style.transform = `translateX(${translateX}%)`;
        
        this.updatePagination();
        
        // Trigger custom event
        this.container.dispatchEvent(new CustomEvent('slideChange', {
            detail: { index: this.currentIndex }
        }));
        
        setTimeout(() => {
            this.isTransitioning = false;
        }, 300);
    }
    
    next() {
        const nextIndex = (this.currentIndex + 1) % this.slides.length;
        this.goToSlide(nextIndex);
    }
    
    prev() {
        const prevIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
        this.goToSlide(prevIndex);
    }
    
    destroy() {
        this.stopAutoplay();
        // Remove event listeners if needed
    }
}

function loadVideoInActiveSlide(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    const videoContainer = activeSlide.querySelector('.video');
    if (videoContainer) {
        const videoEl = videoContainer.querySelector('video');
        const sourceEl = videoEl.querySelector('source');
        if (!sourceEl.src) {
            const videoSrc = sourceEl.dataset.src || videoContainer.dataset.video;
            sourceEl.src = videoSrc;
            videoEl.load();
            videoEl.play();
        } else {
            videoEl.play();
        }
    }

    // Dừng video ở các slide khác
    swiper.slides.forEach((slide, idx) => {
        if (idx !== swiper.activeIndex) {
            const otherVideo = slide.querySelector('video');
            if (otherVideo) {
                otherVideo.pause();
            }
        }
    });
}

// Biến để theo dõi trạng thái swiper images đã được khởi tạo chưa
let swiperImagesInitialized = false;
let customVideoSlider = null;
let customImagesSlider = null;

window.addEventListener("load", function () {
    const isMobile = $('body').data('device-type') === 'mobile';

    if (isMobile) {
        // Sử dụng CustomSlider cho mobile
        const videoContainer = document.querySelector('.swiper-videos');
        const imagesContainer = document.querySelector('.swiper-images');
        
        if (videoContainer) {
            customVideoSlider = new CustomSlider(videoContainer, {
                autoplay: true,
                autoplayDelay: 4000,
                pagination: '.swiper-videos-pagination'
            });
        }
        
        if (imagesContainer) {
            customImagesSlider = new CustomSlider(imagesContainer, {
                autoplay: true,
                autoplayDelay: 4000,
                pagination: '.swiper-images-pagination'
            });
        }
    } else {
        // Sử dụng Swiper cho desktop
        new Swiper(".swiper-videos", {
            pagination: {
                el: ".swiper-videos-pagination",
                clickable: true,
            },
            on: {
                slideChange: function () {
                    loadVideoInActiveSlide(this);
                },
                init: function () {

                }
            },
        });

        // Chỉ khởi tạo swiper images trên desktop ngay lập tức
        new Swiper(".swiper-images", {
            pagination: {
                el: ".swiper-images-pagination",
                clickable: true,
            },
            autoplay: {
                delay: 4000, // 4s chuyển slide
                disableOnInteraction: false, // Không tắt autoplay khi user vuốt
            },
        });
        swiperImagesInitialized = true;
    }

    // Gán sự kiện click cho MJ__toogleActive
    $('#nth-ms-images .list-icons .MJ__toogleActive').on('click', function () {
        
        if ($('body').data('device-type') === 'desktop') {
            const swiperImages = document.querySelector('.swiper-images').swiper;
            swiperImages.update();
            swiperImages.autoplay.start();
            $('#nth-ms-images video').each(function () {
                this.pause();
                this.currentTime = 0; // quay về đầu video luôn
            });
            const swiperVideos = document.querySelector('.swiper-videos').swiper;
            if (swiperVideos) {
                swiperVideos.slideTo(0); // về slide 0
                setTimeout(() => {
                    loadVideoInActiveSlide(swiperVideos);
                }, 10);
            }
        } else if ($('body').data('device-type') === 'mobile') {
            // Xử lý cho mobile với CustomSlider
            if (customImagesSlider) {
                customImagesSlider.goToSlide(0);
                customImagesSlider.startAutoplay();
            }
            
            if (customVideoSlider) {
                customVideoSlider.goToSlide(0);
            }
            
            // Pause tất cả video
            $('#nth-ms-images video').each(function () {
                this.pause();
                this.currentTime = 0;
            });
        }
    });

    $('.btn-bgm').on('click', function (e) {
        e.preventDefault(); // chặn reload trang nếu là thẻ <a>

        // Lấy trạng thái mute đầu tiên
        const isMuted = $('#nth-ms-images video').first().prop('muted');

        // Đảo trạng thái mute cho toàn bộ video
        $('#nth-ms-images video').each(function () {
            this.muted = !isMuted;
        });
    });

});

let loadVid = false;
window.loadSwiper = function () {
    if ($('body').data('device-type') === 'desktop') {
        $('#nth-ms-images video').each(function () {
            this.pause();
            this.currentTime = 0; // quay về đầu video luôn
        });
        setTimeout(() => {
            if ($('#nth-ms-images.frameActive').length > 0) {
                if (loadVid) return;
                loadVid = true;
                const swiperVideos = document.querySelector('.swiper-videos').swiper;
                if (swiperVideos) {
                    loadVideoInActiveSlide(swiperVideos);
                }
            }
        }, 500);
    } else if ($('body').data('device-type') === 'mobile') {
        // Xử lý cho mobile
        $('#nth-ms-images video').each(function () {
            this.pause();
            this.currentTime = 0;
        });
        setTimeout(() => {
            if ($('#nth-ms-images.frameActive').length > 0) {
                if (loadVid) return;
                loadVid = true;
                // Có thể thêm logic load video cho mobile nếu cần
            }
        }, 500);
    }
   
};